export default {"src":"/_next/static/media/Accept.650f880c.svg","height":31,"width":19,"blurWidth":0,"blurHeight":0};